import React from 'react';
import './Stats.css';

const stats = [
    { value: '2013', label: 'Founded' },
    { value: '$220m+', label: 'Funding' },
    { value: '300m+', label: 'Monthly active users' },
    { value: '7b+', label: 'Monthly messages' }
];

function Stats() {
  return (
    <section className="stats-section container">
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card">
            <h5 className="stat-value">{stat.value}</h5>
            <p className="stat-label">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Stats;